import { graphql, useStaticQuery } from 'gatsby'

import { Helmet } from 'react-helmet'
import React from 'react'

interface SeoProps {
  description: string
  lang?: string
  meta?: any
  title: string
  slug: string
  twitterCardImage?: string
  openGraphImage?: string
  canonicalUrl?: string
  prev?: string | boolean
  next?: string | boolean
}

function SEO({
  description = '',
  lang = 'en',
  meta = [],
  title,
  openGraphImage,
  twitterCardImage,
  canonicalUrl,
  slug,
  prev,
  next,
}: SeoProps) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
    }
  `)

  const metaDescription = description || site.siteMetadata.description,
    siteUrl = site.siteMetadata.siteUrl || 'http://localhost:8888/',
    canonUrl = canonicalUrl || `${siteUrl}${slug}`

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: openGraphImage,
        },
        {
          name: 'twitter:image',
          content: twitterCardImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:site`,
          content: '@sporttrade_app',
        },
        {
          name: `twitter:creator`,
          content: '@sporttrade_app',
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: 'facebook-domain-verification',
          content: 'w37u36tqclosa7wu6beiro2rvomz3m',
        },
      ].concat(meta)}
      script={[
        {
          type: 'text/javascript',
          src: `https://www.google.com/recaptcha/api.js?render=${process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}`,
        },
        {
          type: 'text/javascript',
          src: '//nexus.ensighten.com/choozle/17409/Bootstrap.js',
        },
        {
          innerHTML: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${process.env.GATSBY_GOOGLE_TAGMANAGER_ID}'); `,
        },
      ]}
    >
      <link rel="canonical" href={canonUrl} />
      {prev && <link rel="prev" href={`${siteUrl}${prev}`} />}
      {next && <link rel="next" href={`${siteUrl}${next}`} />}

      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,700;0,800;1,500&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  )
}

export default SEO
